export var AirshipFeature;
(function (AirshipFeature) {
    AirshipFeature["Push"] = "push";
    AirshipFeature["TagsAndAttributes"] = "tags_and_attributes";
    AirshipFeature["Contacts"] = "contacts";
    AirshipFeature["FeatureFlags"] = "feature_flags";
    AirshipFeature["Analytics"] = "analytics";
})(AirshipFeature || (AirshipFeature = {}));
export const ALL_FEATURES = Object.values(AirshipFeature);
